import { createSlice } from "@reduxjs/toolkit"
import { DropdownObj } from "../Common/commonTypes"

export type SitesFilters = {
    site: string
    pincode: string
}

export type SitesInternalFilters = {
    state: DropdownObj[]
    city: DropdownObj[]
    status: DropdownObj
    siteType: DropdownObj
    addedBy: DropdownObj[]
    tags: DropdownObj[]
    country_id: DropdownObj
    assigned_to: DropdownObj[]
    capitalisation_status: DropdownObj[]
    ownership_status: DropdownObj[]
    cpo_accounts: DropdownObj[]
    host_accounts: DropdownObj[]
    is_onboarded: DropdownObj
    /** Unset until the user picks Yes / No; only then is is_warehouse sent (see isWarehouseFilter). */
    is_warehouse: DropdownObj
    vehicle_type: DropdownObj[]
    parking_type: DropdownObj[]
    age_op: string
    age: any
    more_than_age: string
    between_age1: string
    between_age2: string
    less_than_age: string
    on_hold: DropdownObj
    added_on: {
        from: string
        id: string
        title: string
        to: string
    }
    added_from: string
    added_to: string
    site_status: DropdownObj[]
    dfc_approval_status: DropdownObj[]
}

type InitialState = {
    filterValues: SitesFilters & SitesInternalFilters
    internalFilterValues: SitesInternalFilters
    page: number
    numOfRows: number
    historyPage: number
    totalPages: number
    siteisNavigated: boolean
    totalSites: number
    historySelectedValue: number
    visibleColumns: { name: string; visible: boolean }[]
}
const baseInternalFilters: SitesInternalFilters = {
    state: [],
    city: [],
    status: {} as DropdownObj,
    siteType: {} as DropdownObj,
    addedBy: [],
    country_id: {} as DropdownObj,
    tags: [],
    age_op: "",
    age: [],
    more_than_age: "",
    between_age1: "",
    between_age2: "",
    less_than_age: "",
    capitalisation_status: [],
    ownership_status: [],
    cpo_accounts: [],
    host_accounts: [],
    is_onboarded: {} as DropdownObj,
    is_warehouse: {} as DropdownObj,
    vehicle_type: [],
    parking_type: [],
    on_hold: {} as DropdownObj,
    assigned_to: [],
    added_on: {
        from: "",
        id: "",
        title: "",
        to: "",
    },
    added_from: "",
    added_to: "",
    site_status: [],
    dfc_approval_status: [],
}
const initialState: InitialState = {
    filterValues: {
        site: "",
        pincode: "",
        ...baseInternalFilters,
    },
    // this stores the values for the filters present in the side drawer
    internalFilterValues: baseInternalFilters,

    page: 1,
    numOfRows: 10,
    historyPage: 1,
    totalPages: 1,
    totalSites: 0,
    historySelectedValue: 10,
    siteisNavigated: false,
    visibleColumns: [
        { name: "Source", visible: false },
        { name: "Added On", visible: false },
        { name: "Added By", visible: false },
        { name: "Ownership Status", visible: false },
        { name: "Capitalised Status", visible: false },
        { name: "Capitalisation Date", visible: false },
        { name: "Decapitalisation Date", visible: false },
        { name: "CSMS Station Id", visible: false },
        { name: "CPO Account", visible: false },
        { name: "Host Account", visible: false },
        { name: "Onboarding Date", visible: false },
        { name: "Site Status", visible: false },
        { name: "Is Warehouse", visible: false },
    ],
}
export const initialInternalFilters: SitesInternalFilters = baseInternalFilters

const SiteSlice = createSlice({
    name: "sites",
    initialState,
    reducers: {
        setPage: (state, action) => {
            state.page = action.payload
        },
        setTotalPage: (state, action) => {
            state.totalPages = action.payload
        },
        setTotalSites: (state, action) => {
            state.totalSites = action.payload
        },
        setNumOfRows: (state, action) => {
            state.numOfRows = action.payload
        },
        setHistoryPage: (state, action) => {
            state.historyPage = action.payload
        },
        setHistorySelectedValue: (state, action) => {
            state.historySelectedValue = action.payload
        },
        setSitesFilters: (state, action) => {
            state.filterValues = action.payload
        },
        setInternalSitesFilters: (state, action) => {
            state.internalFilterValues = action.payload
        },
        setVisibleColumns: (state, action) => {
            state.visibleColumns = action?.payload
        },
        setSiteIsNavigated: (state, action) => {
            state.siteisNavigated = action.payload
        },
    },
})

export const {
    setPage,
    setTotalPage,
    setNumOfRows,
    setSitesFilters,
    setInternalSitesFilters,
    setHistoryPage,
    setVisibleColumns,
    setHistorySelectedValue,
    setSiteIsNavigated,
    setTotalSites,
} = SiteSlice.actions
export default SiteSlice.reducer
